import React, { useCallback, useEffect, useRef, useState } from 'react';
import './sideNav.css';
import SideNavButton from '../components/sideNavButton';
import { CircularProgress } from '@mui/material';
import StepperModal from './mainSections/stepperModal';
import logo from '../assets/images/dashboard/lepton-icono.png'
import { useLocation, useNavigate } from 'react-router-dom';
import FirstSteps from './mainSections/firstSteps';

export const userSections = [
    [
        { label: 'Seguimiento', title: 'Seguimiento de flotas', icon: 'near_me' },
        { label: 'Reportes', title: 'Reportes de flotas e itinerario', icon: 'description' },
        { label: 'Administrar', title: 'Administración de flotas e itinerario', icon: 'pending_actions' },
    ],
    [
        { label: 'Primeros pasos', title: 'Primeros pasos', icon: 'conversion_path' },
        { label: 'Recorrido', title: 'Recorrido', icon: 'flag_check' },
        { label: 'Configuración', title: 'Configuración', icon: 'settings' },
        // { label: 'Cerrar Sesión', title: 'Cerrar Sesión', icon: 'logout' }
    ]
];

export const adminSections = [
    [
        { label: 'Usuarios', title: 'Administración de usuarios', icon: 'manage_accounts' },
        { label: 'Horarios', title: 'Administración de horarios', icon: 'edit_calendar' },
    ],
    [
        { label: 'Cerrar Sesión', title: 'Cerrar Sesión', icon: 'logout' }
    ]
];

const SideNav = ({ isLoading, setIsLoading, onLogout, setActiveSection, isMenuCollapsed, showMovilMenu, setShowMovilMenu, userUpdate, apiUserInfo, setApiUserInfo, userRoute, devices, userSchedules, geoTags, geofences, scheduleRegister, showAlert, updateSchedule }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeOption, setActiveOption] = useState('');
    // const [isLoading, setIsLoading] = useState(false);

    const [openStepperModal, setOpenStepperModal] = useState(apiUserInfo && apiUserInfo.tuto === true ? true : false);
    const [openModal, setOpenModal] = useState(false);

    const asideRef = useRef(null);

    const sections = apiUserInfo && apiUserInfo.type === 'admin' ? adminSections : userSections;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showMovilMenu && asideRef.current && !asideRef.current.contains(event.target)) {
                setShowMovilMenu(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showMovilMenu, setShowMovilMenu]);

    // Leer la sección de la URL cuando el componente se monta
    useEffect(() => {
        const updateActiveSection = () => {
            const pathSection = location.pathname.slice(1).toLowerCase();
            const initialSection = sections.flat().find((section) => section.label.toLowerCase() === pathSection);

            if (initialSection) {
                setActiveOption(initialSection.label);
                setActiveSection(initialSection.label);
            } else {
                setActiveOption(sections[0][0].label);
                setActiveSection(sections[0][0].label);
            }
        };

        updateActiveSection();
    }, [sections]);

    const handleOptionClick = (option) => {
        if (showMovilMenu) setShowMovilMenu(false);
        setActiveOption(option);
        setActiveSection(option);
        navigate(`/${option.toLowerCase()}`);
      };

    const handleLogout = useCallback(() => {
        setIsLoading(true);
        document.cookie = 'session_key=; expires=; path=/;';
        onLogout();
    }, [onLogout]);

    const closeModal = () => {
        // if (apiUserInfo && apiUserInfo.tuto === true) {
        //     userUpdate({ tuto: false });
        //     setApiUserInfo({ ...apiUserInfo, tuto: false });
        // }

        setOpenModal(false);
    }

    const closeStepperModal = () => {
        if (apiUserInfo && apiUserInfo.tuto === true) {
            userUpdate({ tuto: false }, false, false);
            setApiUserInfo({ ...apiUserInfo, tuto: false });
        }

        setOpenStepperModal(false);
    }

    return (
        <aside ref={asideRef} className={`${isMenuCollapsed && !showMovilMenu ? 'collapsed' : ''} ${showMovilMenu ? 'visible' : ''}`}>
            <div className='sidenav'>
                <div className='header_logo_container'>
                    <img className='logo' src={logo} alt='LeptónCheck' />
                    <h2 className='logo_text'>Leptón<span className='primary'>Check</span></h2>
                    <button onClick={() => setShowMovilMenu(false)} className='menu_button'>
                        <span className='material-symbols-rounded'>
                            close
                        </span>
                    </button>
                </div>
                {sections.map((group, groupIndex) => (
                    <div className='sections_group' key={'section-group-' + groupIndex}>
                        {group.map((section, sectionIndex) =>
                            section.label === 'Cerrar Sesión' ? (
                                isLoading ? (
                                    <div key={`loading-${groupIndex}-${sectionIndex}`} style={{ display: 'flex', justifyContent: 'center' }}>
                                        <CircularProgress size={24} />
                                    </div>
                                ) : (
                                    <SideNavButton
                                        key={`sideNav-${groupIndex}-${sectionIndex}`}
                                        label={section.label}
                                        icon={section.icon}
                                        isActive={activeOption === section.label}
                                        onClick={handleLogout}
                                    />
                                )
                            ) : section.label === 'Primeros pasos' ? (
                                <React.Fragment key={`primeros_pasos-${groupIndex}-${sectionIndex}`}>
                                    <SideNavButton
                                        label={section.label}
                                        icon={section.icon}
                                        isActive={activeOption === section.label}
                                        onClick={() => {
                                            if (showMovilMenu) setShowMovilMenu(false);
                                            setOpenStepperModal(true);
                                        }}
                                    />
                                    {openStepperModal && <FirstSteps open={openStepperModal} onClose={closeStepperModal} userRoute={userRoute} userUpdate={userUpdate} devices={devices} userSchedules={userSchedules} geoTags={geoTags} geofences={geofences} scheduleRegister={scheduleRegister} showAlert={showAlert} updateSchedule={updateSchedule} />}
                                </React.Fragment>
                            ) : section.label === 'Recorrido' ? (
                                <React.Fragment key={`recorrido-${groupIndex}-${sectionIndex}`}>
                                    <SideNavButton
                                        label={section.label}
                                        icon={section.icon}
                                        isActive={activeOption === section.label}
                                        onClick={() => {
                                            if (showMovilMenu) setShowMovilMenu(false);
                                            setOpenModal(true);
                                        }}
                                    />
                                    {openModal && <StepperModal open={openModal} onClose={closeModal} />}
                                </React.Fragment>
                            ) : (
                                <SideNavButton
                                    key={`sideNav-${groupIndex}-${sectionIndex}`}
                                    label={section.label}
                                    icon={section.icon}
                                    isActive={activeOption === section.label}
                                    to={`/${section.label.toLowerCase()}`}
                                    onClick={() => {
                                        if (showMovilMenu) setShowMovilMenu(false);
                                        handleOptionClick(section.label);
                                    }}
                                />
                            )
                        )}
                    </div>
                ))}
            </div>
        </aside>
    );
};

export default SideNav;
